import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useNotificationItemStyles = makeStyles((theme) =>
  createStyles({
    notificationItem: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '24px 12px',
      backgroundColor: '#fff',
      marginBottom: 8,

      [theme.breakpoints.down('xs')]: {
        alignItems: 'flex-start'
      }
    },

    notificationItemClose: {
      '&:hover $close': {
        display: 'block'
      }
    },

    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',

      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    },

    avatar: {
      width: 40,
      height: 40
    },

    icon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 40,
      height: 40,
      borderRadius: '50%'
    },

    iconDanger: {
      backgroundColor: theme.palette.secondary.main
    },

    iconDefault: {
      backgroundColor: theme.palette.action.selected
    },

    iconPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    iconProfile: {
      backgroundColor: '#EBEBEB'
    },

    avatarContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: 16
    },

    textWrap: {
      width: '66%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginRight: 16,
      fontSize: 16,

      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
        marginBottom: 8
      }
    },

    text: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      columnGap: '4px',
      lineClamp: 4,
      boxOrient: 'vertical',
      textOverflow: 'ellipsis',

      [theme.breakpoints.down('xs')]: {
        margin: 0
      }
    },

    dateWrap: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',

      [theme.breakpoints.down('xs')]: {
        flexDirection: 'row-reverse'
      }
    },

    dot: {
      minWidth: 4,
      height: 4
    },

    time: {
      [theme.breakpoints.down('xs')]: {
        marginRight: 8
      }
    },

    close: {
      position: 'absolute',
      right: 0,
      top: 0,
      display: 'none'
    }
  })
)
